import React from 'react';
import './style.css';
import { useHistory } from "react-router-dom";


function PageNotFound() {
    const history = useHistory();

    const goToHome = () => {
        history.push('/dashboard');
    }
    return (
        <div className="mainAppDiv">
            <div className='pageNotFound'>
                <p className="pnfTitle">Sorry, we couldn't find that page.</p> <p className="pnf404">404</p>
                <button type="button" className="btn btnSubmit" onClick={goToHome}>Go to Home</button>
            </div >
        </div>

    )
}

export default PageNotFound;